// extracted by mini-css-extract-plugin
module.exports = {"login-layout":"login-layout_login-layout__38LMJ","content":"login-layout_content__30o_s"};